module.exports = __webpack_public_path__ + "img/1.9fa25504.png";